module.exports = __webpack_public_path__ + "media/honey-icons/icon-install-devices-b844591d.svg";